exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cell[data-v-5b4d63bc]{height:100%;width:100%;-webkit-transition:opacity .5s linear;transition:opacity .5s linear;opacity:1;margin:1px}.cell.disabled[data-v-5b4d63bc]{opacity:.5}", ""]);

// exports
